/*
 * ICEKIVI scenes — blob videos stay paused until interaction:
 * hover plays (pause on leave), click/tap toggles (touch devices).
 * Force-mutes via IDL properties so playback never needs a gesture
 * beyond the hover itself.
 */
class IcekiviScenes extends HTMLElement {
  connectedCallback() {
    const shots = [...this.querySelectorAll('.icekivi-scenes__shot')];
    this.cleanups = [];
    shots.forEach((shot) => {
      const v = shot.querySelector('video');
      if (!v) return;
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.autoplay = false;
      v.removeAttribute('autoplay');
      v.pause();

      const play = () => v.play().catch(() => {});
      const pause = () => v.pause();
      const toggle = () => (v.paused ? play() : pause());

      shot.addEventListener('mouseenter', play);
      shot.addEventListener('mouseleave', pause);
      shot.addEventListener('click', toggle);
      this.cleanups.push(() => {
        shot.removeEventListener('mouseenter', play);
        shot.removeEventListener('mouseleave', pause);
        shot.removeEventListener('click', toggle);
      });
    });
  }

  disconnectedCallback() {
    this.cleanups?.forEach((fn) => fn());
  }
}

if (!customElements.get('icekivi-scenes')) {
  customElements.define('icekivi-scenes', IcekiviScenes);
}
